if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading__spinner").classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        const productId = formData.get("product-id");
        const div = document.getElementsByClassName("quantity__input")[0];
        const maxPurchasable = Number(div.getAttribute("data-max-purchasable"));
        checkMaxPurchasable(1, maxPurchasable, productId, `add_to_cart_button`);

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
              checkMaxPurchasable(
                1,
                maxPurchasable,
                productId,
                "after_add_to_cart"
              );
              refreshQuantityInCartBadge(this, formData.get("id"));
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading__spinner").classList.add("hidden");
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

let maxCheckTimeout = null;
let userInteracted = false;

function checkMaxPurchasable(inputValue, maxPurchasable, productId, source) {
  const quantityInput = document.getElementsByClassName(
    "custom-quantity__button"
  )[1];
  const increaseButton = document.getElementsByClassName(
    "custom-quantity__button"
  )[2];
  const addToCartButton = document.getElementsByClassName(
    "custom-product-form__buttons"
  )[0];

  if (!userInteracted) {
    userInteracted = true;
  } else {
    if (addToCartButton) {
      addToCartButton.classList.add("disabled", "disable-click");
    }
    if (maxCheckTimeout) {
      clearTimeout(maxCheckTimeout);
    }
    maxCheckTimeout = setTimeout(() => {
      validateQuantity(
        inputValue,
        maxPurchasable,
        productId,
        quantityInput,
        increaseButton,
        addToCartButton
      );
    }, 500);
    return;
  }
  validateQuantity(
    inputValue,
    maxPurchasable,
    productId,
    quantityInput,
    increaseButton,
    addToCartButton
  );
}

function validateQuantity(
  inputValue,
  maxPurchasable,
  productId,
  quantityInput,
  increaseButton,
  addToCartButton
) {
  fetch(window.Shopify.routes.root + "cart.js")
    .then((response) => response.json())
    .then((data) => {
      const cartContent = [...data.items];

      const totalQty = cartContent
        .filter((item) => Number(item.product_id) === Number(productId))
        .reduce((prev, curr) => prev + Number(curr.quantity), 0);

      const totalRequestedQty = Number(inputValue) + totalQty;

      // For quantity input buttons
      if (totalRequestedQty >= Number(maxPurchasable)) {
        increaseButton.classList.add("disabled", "disable-click");
        quantityInput.classList.add("disabled", "disable-click");
      } else {
        increaseButton.classList.remove("disabled", "disable-click");
        quantityInput.classList.remove("disabled", "disable-click");
      }

      // For Add to Cart button
      if (totalRequestedQty > Number(maxPurchasable)) {
        addToCartButton.classList.add("disabled", "disable-click");
      } else {
        addToCartButton.classList.remove("disabled", "disable-click");
      }
    });
}

function checkMaxPurchaseGroupKey(maxPurchaseGroupKey) {
  fetch(window.Shopify.routes.root + "cart.js")
    .then((response) => response.json())
    .then((data) => {
      var cartContent = [];
      cartContent.push(...data.items);
      const hasSameGroupKeyInCart =
        cartContent.filter(
          (item) => item.properties.maxpurchasegroupkey === maxPurchaseGroupKey
        ).length > 0;

      const addToCartButton = document.getElementsByClassName(
        "product-form__buttons"
      )[0];
      if (hasSameGroupKeyInCart) {
        addToCartButton.classList.add("disabled", "disable-click");
      } else {
        addToCartButton.classList.remove("disabled", "disable-click");
      }
    });
}

function refreshQuantityInCartBadge(productFormEl, variantId) {
  if (!productFormEl || !variantId) return;

  fetch(window.Shopify.routes.root + "cart.js")
    .then((r) => r.json())
    .then((cart) => {
      const qty = (cart.items || [])
        .filter((item) => Number(item.variant_id) === Number(variantId))
        .reduce((sum, item) => sum + Number(item.quantity || 0), 0);

      const wrapper = productFormEl.closest("product-info") || productFormEl;
      const rulesCart = wrapper.querySelector(".quantity__rules-cart");
      if (rulesCart) {
        rulesCart.classList.toggle("hidden", qty === 0);

        const textSpan = rulesCart.querySelector("span");
        if (textSpan) textSpan.textContent = `(${qty} in cart)`;
      }

      const qtyInput = wrapper.querySelector(".quantity__input");
      if (qtyInput) qtyInput.setAttribute("data-cart-quantity", String(qty));
    })
    .catch(console.error);
}

document.addEventListener("DOMContentLoaded", function () {
  const productInfoWrapper = document.getElementsByClassName(
    "product__info-wrapper"
  )[0];
  const div = productInfoWrapper.getElementsByClassName("quantity__input")[0];
  const productId = Number(div.getAttribute("data-product-id"));
  const maxPurchasable = Number(div.getAttribute("data-max-purchasable"));
  const maxPurchaseGroupKey = div.getAttribute("data-max-purchase-group-key");
  checkMaxPurchasable(1, maxPurchasable, productId, "pageload");

  if (maxPurchaseGroupKey !== "") {
    checkMaxPurchaseGroupKey(maxPurchaseGroupKey);
  }
});
